<template>
  <w-flex class="wrap align-center fill-width ma8 column">
    <p>производится загрузка...</p>
    <w-flex>
      <img src="../assets/pepe.gif"/>
    </w-flex>
  </w-flex>
</template>

<script>
export default {
  name: 'Loading'
}
</script>
